import * as THREE from 'three'
import Experience from '../../../Experience'
import vertexShader from './vertex.glsl'
import fragmentShader from './fragment.glsl'

export default class Smoke {
  constructor(environment) {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources
    this.time = this.experience.time
    this.environment = environment
    this.debug = this.experience.debug

    this.setGeometry()
    this.setMaterial()
    this.setMesh()
    this.setDebug() // デバッグ機能を追加

    this.time.on('tick', () => {
      this.update()
    })
  }

  setGeometry() {
    // ジオメトリ
    this.smokeGeometry = new THREE.PlaneGeometry(1, 1, 16, 64)
    this.smokeGeometry.translate(0, 0.5, 0)
    this.smokeGeometry.scale(1.5, 6.0, 1.5)
  }

  setMaterial() {
    // Perlin texture
    const perlinTexture = this.resources.items["perlinTexture0"]
    perlinTexture.wrapS = THREE.RepeatWrapping
    perlinTexture.wrapT = THREE.RepeatWrapping

    this.smokeMaterial = new THREE.ShaderMaterial({
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      uniforms: {
        uTime: new THREE.Uniform(0),
        uPerlinTexture: new THREE.Uniform(perlinTexture),
        uEnvLightIntensity: new THREE.Uniform(1.0)
      },
      side: THREE.DoubleSide,
      transparent: true,
      depthWrite: false,
      // wireframe: true
    })
  }

  setMesh() {
    // メッシュを作成してクラスのプロパティに保存
    this.smoke = new THREE.Mesh(this.smokeGeometry, this.smokeMaterial)
    this.smoke.position.set(-3.45, -0.8, 16)
    this.smoke.rotation.set(0, 0, -0.12)
    this.smoke.scale.x = 0.1
    this.smoke.scale.y = 1.25
    this.scene.add(this.smoke)
  }

  setDebug() {
    // デバッグが有効な場合のみデバッグUIを作成
    if (this.debug.active) {
      // 「Smoke」という名前のフォルダーを作成
      this.debugFolder = this.debug.ui.addFolder('Smoke')
      
      // 位置のデバッグコントロール
      this.debugFolder.add(this.smoke.position, 'x')
        .name('Position X')
        .min(-10).max(10)
        .step(0.01)
        
      this.debugFolder.add(this.smoke.position, 'y')
        .name('Position Y')
        .min(-5).max(15)     // 煙は上に向かうので上限を高めに設定
        .step(0.01)
        
      this.debugFolder.add(this.smoke.position, 'z')
        .name('Position Z')
        .min(-10).max(30)
        .step(0.01)

      // 回転のデバッグコントロール
      this.debugFolder.add(this.smoke.rotation, 'x')
        .name('Rotation X')
        .min(-Math.PI).max(Math.PI)
        .step(0.01)
        
      this.debugFolder.add(this.smoke.rotation, 'y')
        .name('Rotation Y')
        .min(-Math.PI).max(Math.PI)
        .step(0.01)
        
      this.debugFolder.add(this.smoke.rotation, 'z')
        .name('Rotation Z')
        .min(-Math.PI).max(Math.PI)
        .step(0.01)

      // スケールのデバッグコントロールも追加（煙の大きさ調整用）
      this.debugFolder.add(this.smoke.scale, 'x')
        .name('Scale X')
        .min(0.1).max(3.0)
        .step(0.01)
        
      this.debugFolder.add(this.smoke.scale, 'y')
        .name('Scale Y')
        .min(0.1).max(3.0)
        .step(0.01)
        
      this.debugFolder.add(this.smoke.scale, 'z')
        .name('Scale Z')
        .min(0.1).max(3.0)
        .step(0.01)

      // シェーダーマテリアルのuniformsもデバッグできるように追加
      this.debugFolder.add(this.smokeMaterial.uniforms.uEnvLightIntensity, 'value')
        .name('Light Intensity')
        .min(0.0).max(3.0)
        .step(0.01)

      // フォルダーを最初は閉じておく
      this.debugFolder.close()
    }
  }

  update() {
    this.smokeMaterial.uniforms.uTime.value = this.time.elapsed
    this.smokeMaterial.uniforms.uEnvLightIntensity.value = this.environment.environmentMap.intensity
  }
}